import { Highlightable } from '@angular/cdk/a11y'
import { Directive, ElementRef, HostBinding, Input } from '@angular/core'
import { PublicCorpMember } from '../ngrx-store/app.state'

/** One suggestion in MentionTextareaComponent's dropdown, highlighted by its ActiveDescendantKeyManager. */
@Directive({
  selector: '[appMentionOption]',
})
export class MentionOptionDirective implements Highlightable {
  @Input('appMentionOption') member!: PublicCorpMember

  @HostBinding('class.active')
  @HostBinding('attr.aria-selected')
  active = false

  constructor(private el: ElementRef<HTMLElement>) {}

  /** For the textarea's aria-activedescendant. */
  get id(): string {
    return this.el.nativeElement.id
  }

  setActiveStyles(): void {
    this.active = true
    // The panel scrolls - keep the option the arrow keys moved to in view.
    this.el.nativeElement.scrollIntoView?.({ block: 'nearest' })
  }

  setInactiveStyles(): void {
    this.active = false
  }
}
